import React, { Component } from 'react'
import { Doughnut } from 'react-chartjs-2'; 
import author_30_data from '../json/posts_per_author_30.json'

var array_keys = new Array();
var array_values = new Array();

let index = 0
let count = 0
for (var key in author_30_data) {
    if(index<30) {
        array_keys.push(key);
        array_values.push(author_30_data[key]);
    }else{
        count = count + author_30_data[key];
    }
    index++;
}
array_keys.push('Others');
array_values.push(count);

let colors = []
for(var i=0; i<30; i++) {
  colors.push('#'+Math.floor(Math.random()*16777215).toString(16));
}

const data = {
	labels: array_keys,
	datasets: [{
        data: array_values,
        backgroundColor: colors
    }],
};

export class Author30daysChart extends Component {
  render() {
    return (
      <div>
        <h2>作者活跃度统计</h2>
        <Doughnut data={data} /> 
      </div>
    );
  }
}

export default Author30daysChart  
